export default __webpack_public_path__ + "static/media/Cybersecurity_Carousel_banner.40c7d26b.jpg";